import Button from '@/components/Button'
import { useChapter } from '@/context/ChapterContext'
import { useNavigation } from '@/context/NavigationContext'
import { useVideo } from '@/context/VideoContext'

export default function ChapterResume() {
  const { setShowHotspots, currentChapterNumber, totalChapters } = useChapter()
  const { navigateToCredits } = useNavigation()
  const { isPlaying } = useVideo()
  const { nextChapter } = useChapter()

  const handleResume = () => {
    console.log('Resuming chapter', 'navigation')
    setShowHotspots(false)
    if (currentChapterNumber === totalChapters) {
      console.log('Last chapter reached, navigating to credits', 'navigation')
      navigateToCredits()
    } else {
      console.log('Navigating to next chapter', 'navigation')
      nextChapter()
    }
  }

  if (isPlaying) {
    return null
  }

  return (
    <Button small onClick={handleResume}>
      Resume
    </Button>
  )
}
